import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import { toast } from 'react-toastify'
import Select from 'react-select'
import Topbar from '../layouts/Topbar'
import Sidebar from '../layouts/Sidebar'
import { FaSave, FaSpinner } from 'react-icons/fa'
import { useParams, useNavigate } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import '../../HR Manager/screens/CreateEmployee.css'
import { useLocation } from 'react-router-dom';
import API_BASE_URL from '../../../config/api'

const roleOptions = [
  { value: 'employee', label: 'Employee' },
  { value: 'supervisor', label: 'Supervisor' },
]

const HODUpdateEmployee = () => {
  const baseUrl = API_BASE_URL
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation();
  const employeeId = location.state?.employeeId || id; // fallback to URL param
  const [departments, setDepartments] = useState([])
  const [loading, setLoading] = useState(false)
  const [fetchingDepartments, setFetchingDepartments] = useState(true)
  const [fetchingEmployee, setFetchingEmployee] = useState(true)
  const [form, setForm] = useState({
    code: '',
    first_name: '',
    last_name: '',
    department: null,
    national_id: '',
    role: '',
    position: '',
    occupation: ''
  })

  useEffect(() => {
    const fetchDepartments = async () => {
        console.log(employeeId)
      setFetchingDepartments(true)
      try {
        const token = Cookies.get('token')
        const response = await axios.get(`${baseUrl}/api/departments/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        setDepartments(response.data)
      } catch (err) {
        toast.error('Failed to fetch departments.')
      } finally {
        setFetchingDepartments(false)
      }
    }
    fetchDepartments()
  }, [])

  useEffect(() => {
    const fetchEmployee = async () => {
      setFetchingEmployee(true)
      try {
        const token = Cookies.get('token')
        const response = await axios.get(`${baseUrl}/api/employees/${employeeId}/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        console.log(response.data)
        const emp = response.data.employee   
        setForm({
          code: emp.code || '',
          first_name: emp.first_name || '',
          last_name: emp.last_name || '',
          department: emp.department ? { value: emp.department, label: emp.department_name ? `${emp.department_name}${emp.course_center_name ? ` (${emp.course_center_name})` : ''}` : '' } : null,
          national_id: emp.national_id || '',
          role: emp.user.role ? { value: emp.user.role, label: emp.user.role } : null,
          position: emp.position || '',
          occupation: emp.occupation || ''
        })
      } catch (err) {
        toast.error('Failed to fetch employee data.')
      } finally {
        setFetchingEmployee(false)
      }
    }
    if (employeeId) fetchEmployee()
  }, [employeeId])

  const departmentOptions = departments.map(dep => ({
    value: dep.id,
    label: dep.course_center_name ? `${dep.name} (${dep.course_center_name})` : dep.name
  }))

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSelectChange = (selected, { name }) => {
    setForm({ ...form, [name]: selected })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const token = Cookies.get('token')
      await axios.put(`${baseUrl}/api/employees/${employeeId}/`, {
        code: form.code,
        first_name: form.first_name,
        last_name: form.last_name,
        department: form.department?.value,
        national_id: form.national_id,
        role: form.role.value,
        position: form.position,
        occupation: form.occupation
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      toast.success('Employee updated successfully!')
      navigate(-1)
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update employee.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Topbar />
      <Sidebar />
      <div className="create-employee-container">
        
        <div className="content" style={{padding: '20px'}}>
          
          <p style={{fontSize: '16px', fontWeight: '400', color: '#64748b'}}>Update employee information</p>
          <br />
          <div className="employee-form-container" style={{padding: '20px !important'}}>
            {fetchingEmployee ? (
              <div className="loading-state"><FaSpinner className="spinner" /> Loading employee data...</div>
            ) : (
            <form onSubmit={handleSubmit} className="employee-form">
              
              <div className="form-row" style={{marginTop: '20px'}}>
                <div className="form-group" >
                  <label>Code <span className="required">*</span></label>
                  <input
                    type="text"
                    name="code"
                    value={form.code}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  />
                </div>
                <div className="form-group">
                  <label>Department <span className="required">*</span></label>
                  <Select
                    name="department"
                    value={form.department}
                    onChange={handleSelectChange}
                    options={departmentOptions}
                    placeholder={fetchingDepartments ? 'Loading departments...' : 'Select department'}
                    classNamePrefix="react-select"
                    isDisabled={loading || fetchingDepartments}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>First Name <span className="required">*</span></label>
                  <input
                    type="text"
                    name="first_name"
                    value={form.first_name}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  />
                </div>
                <div className="form-group">
                  <label>Last Name <span className="required">*</span></label>
                  <input
                    type="text"
                    name="last_name"
                    value={form.last_name}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>National ID <span className="required">*</span></label>
                  <input
                    type="text"
                    name="national_id"
                    value={form.national_id}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  />
                </div>
                <div className="form-group">
                  <label>Role <span className="required">*</span></label>
                  <Select
                    name="role"
                    value={form.role}
                    onChange={handleSelectChange}
                    options={roleOptions}
                    isDisabled={loading || fetchingEmployee}
                    classNamePrefix="react-select"
                    style={{width: '100%'}}
                  />
                </div>
                
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Occupation <span className="required">*</span></label>
                  <input
                    type="text"
                    name="occupation"
                    value={form.occupation}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  />
                </div>
                <div className="form-group">
                  <label>Position <span className="required">*</span></label>
                  <input
                    type="text"
                    name="position"
                    value={form.position}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  />
                </div>
              </div>
              <div className="form-actions">
                <button
                  type="submit"
                  className="submit-button"
                  disabled={loading || !form.code || !form.first_name || !form.last_name || !form.department || !form.national_id || !form.position || !form.occupation}
                >
                  {loading ? (
                    <>
                      <FaSpinner className="spinner" />
                      <span>Updating Employee...</span>
                    </>
                  ) : (
                    <>
                      <FaSave />
                      <span>Update Employee</span>
                    </>
                  )}
                </button>
              </div>
            </form>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default HODUpdateEmployee
